import { Task } from 'redux-saga';
import { MaxCells, CellIndex } from 'types';
import { race, take, delay, cancel, fork, put } from 'redux-saga/effects';
import {
    dismissVideoError, VideoConnectFailureAction, FrameFailureAction, DisplayVideoErrorAction,
} from 'actions/monitoringActions';

type RaceResult = {
    display?: DisplayVideoErrorAction;
    connect?: VideoConnectFailureAction;
    frame?: FrameFailureAction;
};

//
//  Wait for a video error to happen. Once an error appears, we fork a task to wait
//  a few seconds and then hide the error. We use a fork because it can be cancelled
//  and restarted if a new error arrives before the last one is dismissed.
//
export function* videoErrorWatcher() {
    const cellTasks: Task[] = Array.apply(null, Array(MaxCells)); // stupid syntax, thanks JavaScript.

    while (true) {
        const { display, connect, frame }: RaceResult = yield race({
            display: take('DISPLAY_VIDEO_ERROR'),
            connect: take('VIDEO_CONNECT_FAILURE'),
            frame: take('FRAME_FAILURE'),
        });

        const { cellIndex } = (display || connect || frame)!.meta;

        if (cellTasks[cellIndex]) {
            yield cancel(cellTasks[cellIndex]);
        }
        cellTasks[cellIndex] = yield fork(dismissVideoErrorSaga, cellIndex);
    }
}

export function* dismissVideoErrorSaga(cellIndex: CellIndex) {
    const twoSeconds = 2000;
    yield delay(twoSeconds);
    yield put(dismissVideoError({ cellIndex }));
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/dismissVideoErrorSaga.ts